import React from 'react';
import styled from 'styled-components';
import { Paper, Input, Box, Grid } from '@material-ui/core';
import Slider from '@material-ui/core/Slider';
import ZoomIcon from '@material-ui/icons/ZoomIn';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';

import useCurrentUserId from '../hooks/useCurrentUserId';
import { updateUserCondition } from '../redux/userConditionSlice';
import useUserCondition from '../hooks/useUserCondition';
import { deepCopy } from '../general';

const BottomBarPaper = styled(Paper)`
  position: relative;
  height: 64px;
  z-index: 2;
`
const BootomBarLeft = styled.span`
  display: inline-block;
  width: 100%;
  text-align: left;
`
const ZoomSlider = styled(Slider)`
  z-index: 3;
`

const useStyles = makeStyles({
  root: {
    width: 300,
  },
  input: {
    width: 42,
  },
});

type WorkAreaBottomBarProps = {
  sheetId: string | null;
  scale: number | number[];
  setScale: (scale:number | number[]) => void;
  storyLineLength?: number;
}
const WorkAreaBottomBar: React.FC<WorkAreaBottomBarProps> = ({ sheetId, scale, setScale, storyLineLength }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const userId = useCurrentUserId();
  const [userConditionId, userCondition] = useUserCondition(userId);

  const scaleChange = (newValue:number | number[]) => {
    setScale(newValue);

    if (!userConditionId || !userCondition || !sheetId) return;
    const newZoom = deepCopy(userCondition.zoomRates);
    newZoom[sheetId] = newValue;
    dispatch(updateUserCondition({ id: userConditionId, zoomRates: newZoom }));
  }

  const SliderChange = (newValue:number | number[]) => {
    scaleChange(newValue);
  };

  const InputChange = (newValue:string) => {
    scaleChange(newValue === '' ? 100 : Number(newValue));
  };

  const handleBlur = () => {
    if (typeof scale != 'number') return;

    if (scale < 0) {
      scaleChange(100);
    } else if (scale > 200) {
      scaleChange(200);
    }
  };

  return (
    <BottomBarPaper elevation={0} square>
      <BootomBarLeft>
        <Grid container style={{ marginTop: 8 }}>
          { storyLineLength !== undefined &&
            <Grid item style={{marginLeft: 16, marginRight: 32}}>{ storyLineLength } 行</Grid>
          }
          <Grid item>
            <Box ml={2} className={classes.root}>
              <Grid container spacing={1}>
                <Grid item><ZoomIcon/></Grid>
                <Grid item xs>
                  <ZoomSlider
                      value={typeof scale === 'number' ? scale : 100}
                      onChange={(e, newValue) => {SliderChange(newValue)}}
                      min={0}
                      max={200}
                      aria-labelledby="input-slider"
                  />
                </Grid>
                <Grid item>
                  <Input
                    className={classes.input}
                    value={scale}
                    margin="dense"
                    onChange={(e) => {InputChange(e.target.value)}}
                    onBlur={handleBlur}
                    inputProps={{
                      step: 10,
                      min: 0,
                      max: 200,
                      type: 'number',
                      'aria-labelledby': 'input-slider',
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </BootomBarLeft>
    </BottomBarPaper>
  );
}

export default WorkAreaBottomBar;
